<template>
  <div
    :class="`${isActiveLanguage ? 'language-item active' : 'language-item'}`"
    @click="selectLanguage"
  >
    <div class="language-info">
      <div class="icon">
        <img
          alt=""
          :src="`icons/flags/${code}.png`"
        >
      </div>
      <div class="name">
        {{ name }}
      </div>
    </div>
    <div v-if="isActiveLanguage">
      <img
        src="@/assets/check.svg"
        class="check-icon"
      >
    </div>
  </div>
</template>
<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'MenuLanguageItemComponent',
  emits: ['select'],
  props: {
    code: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    currentLanguage: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isActiveLanguage = computed(() => props.code === props.currentLanguage);

    function selectLanguage() {
      if (!isActiveLanguage.value) {
        emit('select', props.code);
      }
    }

    return {
      isActiveLanguage,
      selectLanguage,
    };
  },
});
</script>

<style lang="scss" scoped>
.language-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  height: 80px;
  max-width: 585px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 0 16px;
  margin-bottom: 20px;
  font-size: 20px;
  line-height: 100%;
  filter: drop-shadow(0px 2px 16px rgba(141, 151, 159, 0.1));

  $sizes:
    $tablet_breakpoint 584px 80px 24px 24px,
    $desktop_s_breakpoint 432px 80px 24px 24px,
    $desktop_m_breakpoint 432px 80px 24px 24px,
    $desktop_l_breakpoint 432px 80px 24px 24px;

  @each $size, $width, $height, $font-size, $padding in $sizes {
    @media screen and (min-width: $size) {
      max-width: $width;
      height: $height;
      font-size: $font-size;
      padding: 0 $padding;
    }
  }

  @media screen and (max-height: $mobile_height_breakpoint) {
    max-width: 336px;
    height: 56px;
    font-size: 20px;
    padding: 0 32px;
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    max-width: 1700px;
    height: 280px;
    font-size: 64px;
    padding: 0 80px;
  }

  .language-info {
    display: flex;
    align-items: center;
  }

  &.active {
    border: 2px solid #007CBA;
    justify-content: space-between;
  }

  .icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 20px;
    border: 1px #666 solid;

    @media screen and (max-height: $mobile_height_breakpoint) {
      margin-right: 16px;
    }

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      width: 100px;
      height: 100px;
      margin-right: 40px;
    }

    img {
      width: inherit;
      height: inherit;
    }
  }

  .name {
    font-weight: 500;
    color: #2A3746;
  }

  .check-icon {
    width: 24px;
    height: 24px;

    $sizes:
      $tablet_breakpoint 32px,
      $desktop_s_breakpoint 32px,
      $desktop_m_breakpoint 32px,
      $desktop_l_breakpoint 32px;

    @each $size, $width in $sizes {
      @media screen and (min-width: $size) {
        width: $width;
        height: $width;
      }
    }

    @media screen and (max-height: $mobile_height_breakpoint) {
      max-width: 24px;
      height: 24px;
    }

    @media screen and (min-height: $big_vertical_screen_breakpoint) {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
